<template>
  <div v-if="!itemRelation" class="text-left">
    <h5>
      {{ labelText }}
    </h5>
    <v-row>
      <v-col cols="12" md="5">
        <v-text-field
          :value="attribute[itemsFromdbText]"
          :label="$t('form.not_item_relation')"
          required
          hide-details
          outlined
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="10" md="5" lg="6">
        <v-autocomplete
          v-model="attribute.id"
          :items="itemsFromdb"
          :item-text="itemsFromdbText"
          item-value="id"
          return-object
          :label="$t('form.select_item_relation')"
          required
          outlined
          ref="select"
          hide-details
          @change="changeSelect($event)"
          :readonly="readOnly"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="2" lg="1" class="justify-center d-flex align-center">
        <v-btn
          class="mr-4"
          @click="submit"
          :disabled="save || readOnly"
          color="light-green"
        >
          {{ $t("button.save") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
  <div v-else class="text-left">
    <h5>
      {{ labelText }}
    </h5>
    <v-row>
      <v-col cols="12" md="6">
        <v-alert dense text type="success">
          {{ $t("processor.itemRelation.correct") }}
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    dataModOp: Object,
    itemsFromdb: Array,
    itemsFromdbText: String,
    field: String,
    state: String,
    labelKey: {
      type: String,
      default: ""
    }
  },
  name: "AssignRelationField",
  data: () => ({
    attribute: "",
    save: true
  }),

  created() {
    this.initialize();
  },

  computed: {
    itemRelation: function() {
      return typeof this.attribute == "number" || this.attribute === null;
    },

    readOnly: function() {
      return this.state === "PC";
    },
    labelText() {
      if (this.labelKey) {
        return this.$t(this.labelKey);
      }
      const translation = this.$t("form." + this.field);
      if (typeof translation === "string") {
        return translation;
      }
      return this.field.charAt(0).toUpperCase() + this.field.slice(1);
    }
  },

  mounted() {
    this.loadSelectedOptions();
  },
  methods: {
    getField(lookup, obj = this.dataModOp.user) {
      for (const x in obj) {
        if (x === lookup) {
          if (typeof obj[x] == "object" && obj[x] !== null) {
            this.attribute = Object.assign({}, obj[x]);
          } else {
            this.attribute = obj[x];
          }
        } else if (obj[x] instanceof Object) {
          this.getField(lookup, obj[x]);
        }
      }
    },
    initialize() {
      if (
        this.dataModOp.supervisor !== undefined &&
        this.dataModOp.supervisor[this.field] !== undefined
      ) {
        this.getField(this.field, this.dataModOp.supervisor);
      } else {
        this.getField(this.field, this.dataModOp.user);
      }
    },

    loadSelectedOptions() {
      if (this.attribute.id != null) {
        this.itemsFromdb.forEach(itemFromdb => {
          if (this.attribute.id === itemFromdb.id) {
            this.$refs["select"].selectedItems = [];
            this.$refs["select"].selectedItems.push(itemFromdb);
          }
        });
      }
    },

    submit() {
      let data = {
        data: {
          user: this.dataModOp.user,
          supervisor: {}
        }
      };
      if (this.dataModOp.supervisor !== undefined) {
        data["data"]["supervisor"] = this.dataModOp.supervisor;
      }
      data["data"]["supervisor"][this.field] = this.attribute;
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/" +
        this.$route.params.id;
      axios
        .patch(path, data)
        .then(response => {
          this.$emit("update-modOp-data", data.data);
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("form.select_item_relation_success")
          });
          this.save = true;
        })
        .catch(error => {
          console.log(error);
          console.log(error.response.data);
          this.$store.commit("alert", {
            color: "error",
            text: error.response.data
          });
        });
    },
    changeSelect(itemSelected) {
      this.attribute.id = itemSelected.id;
      this.save = false;
    }
  }
};
</script>

<style scoped></style>
